module.exports = __webpack_public_path__ + "static/dogovori_sastanak-98910510d50e25021ba85eee3fdee582.svg";